var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"approval__preview"},[(_vm.loading)?_c('page-spinner'):_vm._e(),_c('pdf',{staticClass:"approval__pdf",class:{'approval__pdf_active': _vm.loading === false},attrs:{"src":_vm.src,"page":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }